import React from 'react';
import { AlertMessage } from '../AlertMessage';
import { BulkProgress } from '../../hooks/useBulkAction';
import styles from './styles.module.scss';

interface PropTypes extends BulkProgress {
  actionLabel: string;
}

export function BulkProgressBody(props: PropTypes) {
  const percentage = Math.round((props.queued / props.total) * 100);
  return (
    <div className='py-3'>
      <AlertMessage
        hasOverlay={false}
        icon={{ name: 'bi-info-circle' }}
        className='mb-4 mt-0 fs-5 bg-yellow-light'
        text={<span>Please do not close this window while processing.</span>}
      />
      <div className={styles['progress-wrapper']}>
        <div
          className={styles['progress-fill']}
          role='progressbar'
          style={{ width: `${percentage}%` }}
          aria-valuenow={props.queued}
          aria-valuemin={0}
          aria-valuemax={props.total}
        >
          {percentage > 0 && `${percentage}%`}
        </div>
      </div>
      <p className='mb-0 mt-2 fs-5 text-center'>
        Queuing {props.actionLabel} for{' '}
        <span className='fw-semibold'>
          {props.queued} of {props.total} applications
        </span>
      </p>
    </div>
  );
}
